import { ServiceClient } from '@johnlewispartnership/wtr-website-api-client';

import config from 'config';
import { withApiBaseUrl } from 'services/with-api-base-url';

const BASE_URL = withApiBaseUrl(config.services.trolley.path);

class TrolleyServiceClient extends ServiceClient {
  constructor() {
    super(BASE_URL);
  }
}

const client = new TrolleyServiceClient();

export default client;
